import { render, staticRenderFns } from "./CustomControls.vue?vue&type=template&id=1ec3f870"
import script from "./CustomControls.vue?vue&type=script&lang=js"
export * from "./CustomControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports